<template>
    <div class="topbar">
        <button class="topbar__menu_button" @click="openSidebar" :class="{ active: isActive }">
            <i class="mdi" :class="{ 'mdi-close': isActive, 'mdi-menu': !isActive }"></i>
        </button>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    data() {
        return {
            isActive: false,
        };
    },
    methods: {
        openSidebar() {
            this.$eventHub.$emit('showSidebar');
            this.isActive = !this.isActive;
        },
    },
})
export default class Topbar extends Vue {
    name = 'topbar';
}

Vue.component('topbar', Topbar);
</script>
